/* Add-on buttons: post a variant to the cart without leaving the product page.
 *
 * The point of an upsell row is that it costs nothing to use. Sending someone
 * to another product page to add a £15 pack of bungee cords loses the sale
 * they were already making.
 */
(function () {
  'use strict';

  var RESET_MS = 2200;

  function refreshCartUI() {
    /* Dawn keeps the bubble and drawer in several sections. Re-rendering them
       is cheaper and far less brittle than reaching into its internals. */
    var ids = ['cart-icon-bubble', 'cart-drawer', 'cart-notification'];
    fetch(window.location.pathname + '?sections=' + ids.join(','))
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        if (!data) return;
        ids.forEach(function (id) {
          if (!data[id]) return;
          var target = document.getElementById('shopify-section-' + id);
          if (target) target.innerHTML = data[id];
        });
      })
      .catch(function () {
        /* The item is in the cart either way; a stale badge is not worth
           throwing an error at the shopper over. */
      });
  }

  document.querySelectorAll('[data-addon-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-variant-id');
      if (!id || btn.disabled) return;

      var label = btn.querySelector('[data-addon-label]');
      var original = label ? label.textContent : '';
      btn.disabled = true;
      if (label) label.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          btn.classList.add('mx-addon__btn--done');
          if (label) label.textContent = 'Added';
          refreshCartUI();
        })
        .catch(function () {
          if (label) label.textContent = 'Try again';
        })
        .finally(function () {
          window.setTimeout(function () {
            btn.disabled = false;
            btn.classList.remove('mx-addon__btn--done');
            if (label) label.textContent = original || 'Add';
          }, RESET_MS);
        });
    });
  });
})();
